<template>
  <div class="detail-view">
    <div class="title-box" @click.prevent="toggleInfo">
        <p class="view-title">
          <span v-html="contentInfo.seasontitle"></span>
        </p>
    </div>
    <div class="desc-info-box">
      <vod-genre :content-info="contentInfo" :is-global="isGlobal"/>
    </div>

    <div v-if="!isPooqzone" class="icon-wrap">
      <icon-box-zzim-with-api section="vod" :content-id="contentId" :zzim="zzim"></icon-box-zzim-with-api>
      <a href="#" @click.prevent="moveToDetailInfo()">
        <div class="icon-box share">
          <detail-info-icon></detail-info-icon>
          <span class="icon-txt">상세정보</span>
        </div>
      </a>
    </div>

    <apollo-player-action-button :click-player-fn="clickPlayerFn"
                          :content-info="contentInfo"
                          section="vod"
    ></apollo-player-action-button>

    <div class="desc-box">
      <p class="comment" v-if="comment !== ''">{{ comment }}</p>
      <p class="preview" v-if="synopsis !== ''" v-html="synopsis"></p>
      <div class="cast">
        <table>
          <caption>출연표</caption>
          <colgroup>
            <col style="width: 34px;">
            <col>
          </colgroup>
          <tbody>
            <tr v-if="actorList.length > 0">
              <th>출연:&nbsp;</th>
              <td>
                <div>
                  <span v-for="(actor, index) in actorList" :key="'actors_' + index">
                    {{actor.value}}{{actorList.length - 1 !== index ? ',' : ''}}
                  </span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { topTagList } from '@/common/directives'
import IconBoxSnsShare from '@/components/play/IconBoxSnsShare'
import utils from '@/common/util/utils'
import { get } from 'lodash'
import IconBoxZzimWithApi from '@/components/play/IconBoxZzimWithApi'
import DetailInfoIcon from '@/assets/svg/common/DetailInfoIcon.svg'
import { PATH_NAME_APOLLO_PLAYER_VOD_DETAIL_INFO } from '@/common/router.const'
import { searchByKeyword } from '@/common/util/player.util'
import ApolloPlayerActionButton from '@/components/play/apollo/ApolloPlayerActionButton'
import VodGenre from '@/components/play/VodGenre'

export default {
  name: 'ApolloVodPlayerDetailInfo',
  components: {
    ApolloPlayerActionButton,
    IconBoxZzimWithApi,
    IconBoxSnsShare,
    DetailInfoIcon,
    VodGenre
  },
  directives: {
    topTagList
  },
  data () {
    return {
      isOpenInfoPopup: false,
      isPooqzone: utils.cookies.isPooqZone(),
      isGlobal: false
    }
  },
  props: {
    contentInfo: {
      type: Object
    },
    getToggleButton: {
      type: String
    },
    toggleInfo: {
      type: Function
    },
    tagList: {
      type: Array
    },
    clickTag: {
      type: Function
    },
    clickPlayerFn: {
      type: Function
    },
    toggleState: {
      type: Boolean
    }
  },
  computed: {
    targetage () {
      const age = get(this.contentInfo, 'targetage', '')
      if (age !== '') {
        return age === '0' ? '전체' : `${age}세`
      } else {
        return ''
      }
    },
    zzim () {
      return get(this.contentInfo, 'zzim', 'n').toLowerCase()
    },
    contentId () {
      return get(this.contentInfo, 'programid', '')
    },
    episodeNumber () {
      return get(this.contentInfo, 'episodenumber', '').replace('회', '')
    },
    comment () {
      return get(this.contentInfo, 'comment', '')
    },
    synopsis () {
      return get(this.contentInfo, 'synopsis', '')
    },
    actorList () {
      return get(this.contentInfo, 'actors.list', [])
    }
  },
  methods: {
    searchByKeywordFn (keyword) {
      searchByKeyword({ keyword, isDetailInfo: false })
    },
    moveToDetailInfo () {
      this.$router.push({
        name: PATH_NAME_APOLLO_PLAYER_VOD_DETAIL_INFO,
        query: {
          programid: get(this.$route, 'query.programid', ''),
          contentid: get(this.$route, 'query.contentid', '')
        }
      })
    }
  },
  created () {
    const GLOBAL_VOD_GENRE_CODE = '09'
    this.isGlobal = get(this.contentInfo, 'genrevalue', '') === GLOBAL_VOD_GENRE_CODE
  }
}
</script>
